export enum DealStateType {
    Lead = 'Lead',
    Open = 'Open',
    Won = 'Won',
    ToInvoice = 'To invoice',
    InvoiceSent = 'Invoice sent',
    Archive = 'Archive',
}
